import type { DeviceVariantType } from '@unifyapps/defs/types/deviceVariant';
import type { BlockType } from '@unifyapps/defs/types/block';
import type { InterfaceStoreType } from './types';

export const getActivePage = (getState: () => InterfaceStoreType) => {
  const state = getState();
  return state.interfacePages[state.activeInterfacePageId];
};

export const getBlocksFromPage = (
  device: DeviceVariantType,
  store: InterfaceStoreType,
): Record<string, BlockType | undefined> => {
  const activePage = store.activeInterfacePageId;
  const baseBlocks = store.interfacePages[activePage].properties.blocks;
  const deviceBlocks = store.interfacePages[activePage].properties.devices?.[device]?.blocks;

  if (!deviceBlocks) {
    return baseBlocks ?? {};
  }

  return {
    ...baseBlocks,
    ...deviceBlocks,
  };
};

export const getInterfaceRecord = (getState: () => InterfaceStoreType) => {
  const state = getState();
  return state.interfaceRecord;
};

export const getPageVariableDetails = (getState: () => InterfaceStoreType, variableId: string) => {
  const activePage = getActivePage(getState);
  return activePage.properties.pageVariables?.[variableId];
};
